export class AccountSellerLinkResponse {
  constructor(public readonly link: string) {}
}
